export default __webpack_public_path__ + "images/L5.cfbb1c2.png";